
import { ICard } from "../types/cardType"
import ReactGA from "react-ga4";


 export const rearrangeItems = (value : string, definedTours : ICard[], referer:string) => {
        let tmp = definedTours
        //sort by tourname
        if(value === '1'){
            tmp.sort(function (a : ICard, b : ICard) {
                if(a.DDTourName < b.DDTourName){
                    return -1
                }else if(a.DDTourName > b.DDTourName){
                    return 1
                }
                return 0
            })
            return tmp
        }
        //sort by duration
        if(value === '2'){   
            tmp.sort(function (a : ICard,b : ICard) {
                let aDays = Number(a.DDDaysNights.split('days')[0])
                let bDays = Number(b.DDDaysNights.split('days')[0])
                if(aDays < bDays){
                    return -1
                }else if(aDays > bDays){
                    return 1
                }
                return 0
            })
            return tmp
        }
        //sort by price
        if(value === '3'){
            tmp.sort(function (a : ICard, b : ICard) {
               let aIntGBP = Number(a.DDGBP.replace(/,/g,''))
               let bIntGBP = Number(b.DDGBP.replace(/,/g,''))
               let aIntEUR = Number(a.DDEUR.replace(/,/g,''))
               let bIntEUR = Number(b.DDEUR.replace(/,/g,''))
                if(referer === 'UK' ? aIntGBP < bIntGBP : aIntEUR < bIntEUR ){
                    return -1
                }else if(referer === 'UK' ? aIntGBP > bIntGBP : aIntEUR > bIntEUR ){
                    return 1
                }
                return 0
            })
            return tmp
        }
        //sort by location
        if(value === '4'){
            tmp.sort(function (a : ICard, b : ICard) {
                if(a.DDStartPoint < b.DDStartPoint){
                    return -1
                }else if(a.DDStartPoint > b.DDStartPoint){
                    return 1
                }
                return 0
            })
            return tmp
        }
    }

    //convert to an array of arrays of length 30 for pagination purposes
    export const paginateTours = (tours: ICard[]): ICard[][] => {
        const result: ICard[][] = [];
        const chunkSize = 30;
        for (let i = 0; i < tours.length; i += chunkSize) {
            result.push(tours.slice(i, i + chunkSize));
        }
        return result;
    };

    //get unique values for the filter menu
    export const getUniqueValues = (array: ICard[], field: string): string[] => {
            return [...new Set(array.map((item: any) => item[field]))];
    };
    
    //generate key for data service
    export const getKey = (params : string) => {
        //needs to return level1level2level3 etc or tourpartner eg g-adventures // south-east-asiathailand
      let key = '';
        if (params.includes('/tours/partner')){
         key = params.replace(/\/tours\/partner\//, '');
        } else {
         key = params.replace(/\bpartner\b|\btours\b|\/+/gi, '');
        }
      return key
    }

    //send ga4 analytics data
    export const sendAnalyticsData = (eventAction:string, eventLabel : string) => {
        ///this isn't yet in use. if we use in the future, GA will need to be initialised first at top level
        ReactGA.event({
            category: "tourShare",
            action: eventAction,
            label: eventLabel, 
          });
    }

    export const formatPrice = (price: string) => {

      if (price?.includes(',')){
        return price
      } else {
        let numberPrice= Number(price)
        return numberPrice.toLocaleString()
      }
    }